// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"544":"8cc11086","568":"16a7e60e","684":"a2560c56"}[chunkId] + ".chunk.js";
};